/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { WorktypesDaoService } from '../worktypes-dao.service';
import { Worktype } from 'src/app/_model/workttype';

// CONSTANTS
const WORKTYPES_KEY = 'worktypes';

@Injectable()
export class WorktypesStorageDaoService implements WorktypesDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveWorktypes(worktypes: Worktype[]): Promise<void> {
    return this.keyValueStorage.store(WORKTYPES_KEY, worktypes);
  }
  
  public async getWorktypes(): Promise<Worktype[]> {
    const workTypeDtos = await this.keyValueStorage.load(WORKTYPES_KEY);
    return workTypeDtos?.map((dto: any) => {
      return Worktype.fromDto(dto?.databag);
    }) || [];

  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(WORKTYPES_KEY);
  }
}
